import styled from 'styled-components'

export const IntroWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const IntroCard = styled.div`
  flex: 1 1 420px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ theme }) => theme.card || 'rgba(255,255,255,0.03)'};
  color: ${({ theme }) => theme.text};
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(2,6,23,0.35);
  min-width: 280px;
`;

export const NameHeader = styled.h1`
  margin: 0 0 8px 0;
  font-size: 1.75rem;
  letter-spacing: -0.02em;
`;

export const TraitText = styled.h2`
  margin: 0 0 12px 0;
  font-size: 1.05rem;
  color: ${({ theme }) => theme.accent || '#aef1fa'};
  font-weight: 600;
  transition: opacity 420ms ease;
  opacity: 1;
`;

export const BioText = styled.p`
  margin: 0;
  line-height: 1.55;
  color: ${({ theme }) => theme.subtleText || 'rgba(255,255,255,0.85)'};
  font-size: 1rem;
`;

export const ImagesWrapper = styled.div`
  flex: 0 1 360px;
  min-width: 240px;
  display: flex;
  align-items: stretch;

  @media (max-width: 900px) {
    flex: 1 1 100%;
    order: 2;
  }
`;

export const BottomBio = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
`;

const AboutMeStyles = {
  IntroWrapper,
  IntroCard,
  NameHeader,
  TraitText,
  BioText,
  ImagesWrapper,
};

export default AboutMeStyles;
